var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" />
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var UserService = /** @class */ (function (_super) {
            __extends(UserService, _super);
            function UserService($http, $q, localStorageService) {
                var _this = _super.call(this, $http) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.localStorageService = localStorageService;
                _this.userNameHashTable = {};
                _this.allQueryIssued = false;
                return _this;
            }
            UserService.prototype.setLoggedInUserId = function (userId) {
                this.loggedInUserId = userId;
            };
            UserService.prototype.setImpersonationUserId = function (userId) {
                this.impersonationUserId = userId;
            };
            UserService.prototype.clearImpersonationUserId = function () {
                this.impersonationUserId = undefined;
            };
            UserService.prototype.isCurrentlyImpersonating = function () {
                return this.impersonationUserId !== undefined;
            };
            UserService.prototype.getLoggedInUserId = function () {
                return this.impersonationUserId ? this.impersonationUserId : this.loggedInUserId;
            };
            UserService.prototype.getCurrentUser = function () {
                var data = this.localStorageService.get("authorizationData");
                if (data) {
                    return (data);
                }
                return null;
            };
            UserService.prototype.getUser = function (userId) {
                var d = this.$q.defer();
                this.$http.get("./api/Account/GetUser/" + userId).then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            UserService.prototype.getCurrentUserClaims = function (processConfigId) {
                var d = this.$q.defer();
                this.$http.get("./api/claims/UserClaims/" + processConfigId)
                    .then(function (claims) {
                    d.resolve(claims.data);
                });
                return d.promise;
            };
            UserService.prototype.searchUsers = function (searchCriteria) {
                var d = this.$q.defer();
                if (searchCriteria.userRepository && searchCriteria.userRepository !== "") {
                    this.$http.get("./api/Account/SearchExternalAccounts/" + searchCriteria.userName + "/" + searchCriteria.userRepository).then(function (r) {
                        d.resolve(r.data);
                    });
                }
                else {
                    this.$http.get("./api/Account/SearchAccounts/" + searchCriteria.userName).then(function (r) {
                        d.resolve(r.data);
                    });
                }
                return d.promise;
            };
            UserService.prototype.addExternalUser = function (userSearchDto) {
                var d = this.$q.defer();
                this.$http.post("./api/Account/AddExternalAccount", userSearchDto).then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            return UserService;
        }(services.HttpHandlerService));
        services.UserService = UserService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService("UserService", ["$http", "$q", "localStorageService",]);
